<ng-container *ngIf="!!hotelReservation">
  <app-ds-generic-card
    [space]="genericCardSpaces.None">
    <div class="hotel-resume-cont">
      <div class="hotel-resume-header" [class.no-line]="!!referenceCode">
        <div class="hotel-name" (click)="showMoreInfo.emit()">
          <app-ds-typography 
            [fontFamily]="fontFamily.SemiBold" 
            [size]="fontSize.XXS"
            [color]="fontColor.Primary"
            [text]="'PACKAGES_MODULES.PACKAGE_BOOKING.YOUR_HOTEL' | transloco : { name: hotelReservation.Hotel?.HotelName }">
          </app-ds-typography>
        </div>
        <i aria-hidden="true" (click)="showMoreInfo.emit()" class="icon-expand"></i>
      </div>
      <div class="reference-code" *ngIf="!!referenceCode">
        <div class="hotel-ref">
          <app-ds-typography 
            [fontFamily]="fontFamily.Regular" 
            [size]="fontSize.XXS"
            [color]="fontColor.Primary"
            [text]="'PACKAGES_MODULES.PACKAGE_BOOKING.YOUR_HOTEL_REFERENCE_CODE' | transloco : { code: referenceCode }">
          </app-ds-typography>
        </div>
        <div class="icon-cont">
          <app-copy-to-clipboard
            [copyInfo]="referenceCode"
            [parentClass]="'text-tooltip-clipboard'">
          </app-copy-to-clipboard>
        </div>
      </div>
      <div class="hotel-info">
        <div class="registration">
          <div class="check-in">
            <app-ds-typography 
              [fontFamily]="fontFamily.SemiBold" 
              [size]="fontSize.XXS"
              [color]="fontColor.Primary"
              [text]="'PACKAGES_MODULES.PACKAGE_BOOKING.HOTEL_RESERVATION.CHECK_IN' | transloco">
            </app-ds-typography>
            <app-ds-typography 
              [fontFamily]="fontFamily.Regular" 
              [size]="fontSize.XXS"
              [color]="fontColor.Primary"
              [text]="checkinDate | date:'EEEE, d MMM yyyy' | titlecase">
            </app-ds-typography>
          </div>
          <div class="check-out">
            <app-ds-typography 
              [fontFamily]="fontFamily.SemiBold" 
              [size]="fontSize.XXS"
              [color]="fontColor.Primary"
              [text]="'PACKAGES_MODULES.PACKAGE_BOOKING.HOTEL_RESERVATION.CHECK_OUT' | transloco">
            </app-ds-typography>
            <app-ds-typography 
              [fontFamily]="fontFamily.Regular" 
              [size]="fontSize.XXS"
              [color]="fontColor.Primary"
              [text]="checkoutDate | date:'EEEE, d MMM yyyy' | titlecase">
            </app-ds-typography>
          </div>
        </div>
        <div class="registration">
          <div class="nighs top">
            <app-ds-typography 
            [fontFamily]="fontFamily.SemiBold" 
            [size]="fontSize.XXS"
            [color]="fontColor.Primary"
            [text]="'PACKAGES_MODULES.PACKAGE_BOOKING.HOTEL_RESERVATION.NIGHTS' | transloco">
          </app-ds-typography>
            <ng-container *ngTemplateOutlet="nightsCounter"></ng-container>
          </div>
        </div>
      </div>
    </div>
  </app-ds-generic-card>
</ng-container>

<ng-template #nightsCounter>
  <ng-container *ngIf="isOneNight; else multipleNights">
    <app-ds-typography
      [tag]="'span'"
      [fontFamily]="fontFamily.Regular" 
      [size]="fontSize.XXS"
      [color]="fontColor.Primary"
      [text]="'PACKAGES_MODULES.PACKAGE_BOOKING.HOTEL_RESERVATION.ONE_NIGHT' | transloco">
    </app-ds-typography>
  </ng-container>
  <ng-template #multipleNights>
    <app-ds-typography
      [tag]="'span'"
      [fontFamily]="fontFamily.Regular" 
      [size]="fontSize.XXS"
      [color]="fontColor.Primary"
      [text]="'PACKAGES_MODULES.PACKAGE_BOOKING.HOTEL_RESERVATION.MULTIPLE_NIGHTS' | transloco : { quantity: nights }">
    </app-ds-typography>
  </ng-template>
</ng-template>
